export default {
  "SorryPage.DocumentTitle": "パーソナルデータの取扱いに関する同意事項",
  "SorryPage.ContainerContentPc1":
    "サーバメンテナンス中のため、同意事項を取得できませんでした",
  "SorryPage.ContainerContentPc2": "お客さまに同意いただく内容は、",
  "SorryPage.ContainerContentPc3":
    "ドコモおよびドコモフィナンシャルグループの公式ホームページから",
  "SorryPage.ContainerContent1": "サーバメンテナンス中のため、",
  "SorryPage.ContainerContent2": "同意事項を取得できませんでした",
  "SorryPage.ContainerContent3": "お客さまに同意いただく内容は、",
  "SorryPage.ContainerContent4":
    "ドコモおよびドコモフィナンシャルグループの公式ホームページから",
  "SorryPage.ContainerContentTextSorry1":
    "「パーソナルデータ（個人情報など）について ＞ パーソナルデータの取扱いに関する同意事項」",
  "SorryPage.ContainerContentTextSorry2": "をご確認ください",
}
